import React from 'react';

import { flagStyles } from '../settings';

const SvgGH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1968px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGH;
